// extracted by mini-css-extract-plugin
export default {"fill":"EllipsisVertIcon_fill__A-q5a"};